import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Navbar from "./components/Navbar";
import PrivateRoute from "./components/PrivateRoute";
import DashboardAdmin from "./pages/DashboardAdmin";
import Dashboard1Party from "./pages/Dashboard1Party";
import Dashboard2Party from "./pages/Dashboard2Party";
import Dashboard3Party from "./pages/Dashboard3Party";
import Dashboard4Party from "./pages/Dashboard4Party";
import Dashboard5Party from "./pages/Dashboard5Party";
import DashboardPhotoOffice from "./pages/DashboardPhotoOffice";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin-dashboard" element={<PrivateRoute Component={DashboardAdmin} role="admin" />} />
        <Route path="/1party-dashboard" element={<PrivateRoute Component={Dashboard1Party} role="1Party" />} />
        <Route path="/2party-dashboard" element={<PrivateRoute Component={Dashboard2Party} role="2Party" />} />
        <Route path="/3party-dashboard" element={<PrivateRoute Component={Dashboard3Party} role="3Party" />} />
        <Route path="/4party-dashboard" element={<PrivateRoute Component={Dashboard4Party} role="4Party" />} />
        <Route path="/5party-dashboard" element={<PrivateRoute Component={Dashboard5Party} role="5Party" />} />
        <Route path="/photooffice-dashboard" element={<PrivateRoute Component={DashboardPhotoOffice} role="PhotoOffice" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;